<!-- prettier-ignore -->

<div class="headerLicense">
    @if(showSpinner){
        <ion-spinner id="spinner" style="margin: 0 auto; display: block; width: 75px; height: 75px;" style="--color: #fff; width: 80px !important; height: 80px !important;"></ion-spinner>
    }
    @else{
        <span style="color: #fff; font-size: 28px;">Error al cargar la ruta</span>
    }
</div>
